import React from 'react';
import './InitialsAvatar.css';

type InitialsAvatarProps = {
  name?: string;
  email?: string;
  size?: number;
  className?: string;
};

function deriveInitials(name?: string, email?: string): string {
  const trimmedName = (name ?? '').trim();
  if (trimmedName) {
    const parts = trimmedName.split(/\s+/);
    if (parts.length === 1) return parts[0]!.charAt(0).toUpperCase();
    return (parts[0]!.charAt(0) + parts[parts.length - 1]!.charAt(0)).toUpperCase();
  }
  const trimmedEmail = (email ?? '').trim();
  if (trimmedEmail) return trimmedEmail.charAt(0).toUpperCase();
  return '?';
}

const InitialsAvatar: React.FC<InitialsAvatarProps> = ({ name, email, size = 34, className }) => {
  const initials = deriveInitials(name, email);
  const label = `avatar for ${name?.trim() || email?.trim() || 'unknown user'}`;
  const cls = className ? `geisti-initials-avatar ${className}` : 'geisti-initials-avatar';
  return (
    <span
      className={cls}
      role="img"
      aria-label={label}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.42) }}
    >
      {initials}
    </span>
  );
};

export default InitialsAvatar;
